import React, {ReactElement} from "react";

import Image, {ImageObject} from "../../image/Image";
import ModuleBody from "../../layouts/module-body/ModuleBody";

import {css, generateKeyId} from "/src/utils/utils";

import * as styles from "./fast-facts-stacked.module.scss";
import FastFactStacked from "../../cards/fast-fact-stacked/FastFactStacked";

export interface FastFactsStackedProps {
  title?: string;
  image?: ImageObject;
  facts?: Array<Queries.FastFactFragmentFragment>;
}

const FastFactsStacked = (props: FastFactsStackedProps): ReactElement => {
  const {title, image, facts} = props;

  return (
    <section className={styles.fastFactsStacked}>
      <ModuleBody classes={styles.fastFactsStacked__body}>
        {title && (
          <h2 className={css("h2", styles.fastFactsStacked__title)}>{title}</h2>
        )}

        <div className={styles.fastFactsStacked__facts}>
          {facts &&
            facts.map((fact, i) => (
              <FastFactStacked
                eyebrow={fact?.eyebrow!}
                headline={fact?.headline!}
                trailing={fact?.headlineTrailing!}
                body={fact?.body?.body!}
                key={generateKeyId(`fast-fact-stacked-${fact.headline}-${i}`)}
              />
            ))}
        </div>

        {image && (
          <div className={styles.fastFactsStacked__image}>
            <Image image={image} />
          </div>
        )}
      </ModuleBody>
    </section>
  );
};

export default FastFactsStacked;
